import React from "react";

const STATUS = {
  created: { label: "Created", cls: "bg-slate-500/20 text-slate-300 border-slate-500/30" },
  processing: { label: "Processing", cls: "bg-amber-500/20 text-amber-300 border-amber-500/30" },
  notice_sent: { label: "Notice Sent", cls: "bg-blue-500/20 text-blue-300 border-blue-500/30" },
  removed: { label: "Removed", cls: "bg-green-500/20 text-green-300 border-green-500/30" },
  failed: { label: "Failed", cls: "bg-red-500/20 text-red-300 border-red-500/30" },
};

export function StatusBadge({ status }) {
  const s = STATUS[status] || STATUS.created;
  return (
    <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-semibold border ${s.cls}`} data-testid={`status-${status}`}>
      {s.label}
    </span>
  );
}

export function EnvBadge({ environment }) {
  const prod = environment === "production";
  const invalid = environment === "invalid";
  return (
    <span
      className={`inline-block px-3 py-1 rounded-full text-xs font-bold border ${prod || invalid ? "bg-red-500/20 text-red-300 border-red-500/40" : "bg-yellow-500/20 text-yellow-300 border-yellow-500/40"}`}
      data-testid="takedown-env-badge"
    >
      {invalid ? "Invalid environment" : prod ? "Production" : "Sandbox"}
    </span>
  );
}

export const errMsg = (e, fallback = "Request failed") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg?.replace(/^Value error, /, "")).filter(Boolean).join("; ") || fallback;
  return d?.message || fallback;
};
